import { create } from "zustand";
import { fetchEnviosLoteado } from "../firebase/firestore/envios";
import type { Envio } from "../firebase/firestore/envios";
import type { QueryDocumentSnapshot } from "firebase/firestore";
import { useDateRangeStore } from "./useDateRangeStore";

type EnvioStore = {
  allEnvios: Envio[];
  lastDoc?: QueryDocumentSnapshot;
  hasMore: boolean;
  fetchAllEnvios: () => Promise<void>;
  fetchNextPage: () => Promise<void>;
  resetEnvios: () => void;
};

export const useEnvioStore = create<EnvioStore>((set, get) => ({
  allEnvios: [],
  lastDoc: undefined,
  hasMore: true,

  fetchAllEnvios: async () => {
    const { fechaInicio, fechaFin } = useDateRangeStore.getState();
    const { envios, lastDoc } = await fetchEnviosLoteado(
      fechaInicio.startOf("day").toDate(),
      fechaFin.endOf("day").toDate()
    );

    set({
      allEnvios: envios,
      lastDoc,
      hasMore: !!lastDoc,
    });
  },

  fetchNextPage: async () => {
    const { fechaInicio, fechaFin } = useDateRangeStore.getState();
    const { lastDoc: currentLastDoc, hasMore } = get();

    if (!hasMore) return;

    const { envios, lastDoc: newLastDoc } = await fetchEnviosLoteado(
      fechaInicio.startOf("day").toDate(),
      fechaFin.endOf("day").toDate(),
      currentLastDoc
    );

    set((state) => ({
      allEnvios: [...state.allEnvios, ...envios],
      lastDoc: newLastDoc,
      hasMore: !!newLastDoc,
    }));
  },

  resetEnvios: () => {
    set({
      allEnvios: [],
      lastDoc: undefined,
      hasMore: true,
    });
  },
}));
